import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'

const FilterGroupToggle = ({
  expanded,
  toggleOnName = 'More options',
  toggleOffName = 'Less options',
  toggleHandlers: {
    onClick
  },
  ...props
}) =>
  <Toggler data-at-filtergroup-toggle link bolder aria-expanded={ expanded } onClick={ onClick } { ...props }>
    {expanded ? toggleOffName : toggleOnName}
  </Toggler>

export default FilterGroupToggle

FilterGroupToggle.propTypes = {
  expanded: PropTypes.bool,
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  }),
  toggleOffName: PropTypes.string,
  toggleOnName: PropTypes.string
}

const Toggler = styled(Button)`
  && {
    display: inline-block;
    margin-top: 15px;
    padding: 0;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`
